import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { ColumnContainer } from 'utils/columnsStyle';
import { useDispatch, useSelector } from 'react-redux';
import { useToggle } from "hooks/useToggle";
import { ModalV2 } from 'components/Modal/ModalV2'
import {
  editComoDataMode,
  comoDataSelected,
  deleteComoData
} from 'redux/actions/comoData/comoDataActions';

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
}

export const columns = [
  {
    Header: "Cliente",
    accessor: "customer.name",
    id: 'customerName',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id].toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Número cliente",
    accessor: "customer.number",
    id: 'customerNumber',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id].toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Inversion",
    accessor: "totalInversion",
    filterable: true,
    filterMethod: (filter, row) => row.totalInversion?.toString().toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Kilos por mes",
    accessor: "kgPerMonth",
    filterable: true,
    filterMethod: (filter, row) => row.kgPerMonth?.toString().toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Fecha inicio",
    accessor: "startDate",
    filterable: true,
    filterMethod: (filter, row) => row.startDate?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Vigencia",
    accessor: "endDate",
    filterable: true,
    filterMethod: (filter, row) => row.endDate?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Acciones",
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch()
      const { rules } = useSelector(({ login }) => login)
      const [openDel, setOpenDel] = useToggle()
      const openEdit = () => {
        dispatch(editComoDataMode())
        original.modal(true)
        dispatch(comoDataSelected(original.id))
      }
      const submitEliminate = (e) => {
        e.preventDefault()
        dispatch(deleteComoData(original.id))
      }

      return (
        <ColumnContainer>
          <EditIcon style={style} onClick={openEdit} />
          {
            rules.includes('COMMODATOS-DELETE') && <DeleteIcon style={{ ...style, color: '#e83737' }} onClick={setOpenDel} />
          }
          <ModalV2
            open={openDel}
            onClose={setOpenDel}
            title={`¿Desea eliminar comodatos del cliente ${original?.customer?.name}?`}
            justConfirm
            onSubmit={submitEliminate}
          />
        </ColumnContainer>
      )
    },
  },
];

export const tanksColumns = [
  {
    Header: "Marca",
    accessor: "brandName",
    filterable: true,
    filterMethod: (filter, row) => row.brandName.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Serie",
    accessor: "serie",
    filterable: true,
    filterMethod: (filter, row) => row.serie.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Activo Fijo",
    accessor: "fixedAssetNum",
    filterable: true,
    filterMethod: (filter, row) => row.fixedAssetNum?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Capacidad",
    accessor: "capacity",
    filterable: true,
    filterMethod: (filter, row) => row.capacity?.toString()?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Acciones",
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      return (
        <ColumnContainer>
          <DeleteIcon style={{ ...style, color: '#e83737' }} onClick={() => original.setDeleteTank({...original, label: `${original.brandName} - ${original.serie}`})} />
        </ColumnContainer>
      )
    },
  },
]